module.exports = __webpack_public_path__ + "assets/diamond.f467ad6f.svg";